/**
 * @Description 创建机会点 周边门店信息
 */
import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import StoreInfoTab from './StoreInfoTab';
import BrandList from './BrandList';
import { FC, useEffect, useState } from 'react';
import StoreTableList from './StoreTableList';
import { useMethods } from '@lhb/hook';
import { chancePointPoiTypes } from '@/common/api/expandStore/chancepoint';
import { FAMOUS_BRAND } from '../ts-config';
import { Spin } from 'antd';

const StoreInfo: FC<any> = ({
  centerAddress,
  tableFilter,
  setTableFilter,
  curDetail,
  setCurDetail,
}) => {
  const [currentIndex, setCurrentIndex] = useState(null); // 一级分类下标
  const [currentSecondIndex, setCurrentSecondIndex] = useState(null); // 二级分类下标
  const [tabOptions, setTabOptions] = useState<any>([]); // 周边门店分类列表数据
  const [initLoaded, setInitLoaded] = useState(false); // 是否初始化加载完成


  useEffect(() => {
    if (centerAddress?.lat && centerAddress?.lng) {
      setTableFilter({
        cityId: centerAddress?.cityId,
        centerLng: centerAddress?.lng,
        centerLat: centerAddress?.lat
      });
      methods.getTabOptions();
    }
  }, [centerAddress]);

  const methods = useMethods({
    getTabOptions() {
      const { lng, lat, cityId } = centerAddress;
      chancePointPoiTypes({ cityId, centerLng: lng, centerLat: lat }).then((res) => {
        setTabOptions(res.poiTypeList || []);
      }).finally(() => {
        setInitLoaded(true);
      });
    }
  });

  return (
    <div className={styles.storeContentWrapper}>
      <V2Title divider type='H2' text={`经营门店`}/>
      { !initLoaded && <div className={styles.storeContentSpin}><Spin /></div> }
      { !!tabOptions?.length && (
        <StoreInfoTab
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          currentSecondIndex={currentSecondIndex}
          setCurrentSecondIndex={setCurrentSecondIndex}
          tabOptions={tabOptions}
          tableFilter={tableFilter}
          setTableFilter={setTableFilter}
          setCurDetail={setCurDetail}
        />
      ) }
      { currentIndex === FAMOUS_BRAND && tableFilter.poiType && (
        <BrandList tableFilter={tableFilter} curDetail={curDetail} setCurDetail={setCurDetail} />
      )}
      { currentIndex !== FAMOUS_BRAND && tableFilter.poiType && (
        <StoreTableList tableFilter={tableFilter} curDetail={curDetail} setCurDetail={setCurDetail} />
      )}
    </div>
  );
};

export default StoreInfo;
